// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responders-heading[data-v-20bbf06e]{display:grid;grid-template-columns:auto 75px}.responder[data-v-20bbf06e],.responder .target-container[data-v-20bbf06e]{width:100%}.responder .target-container[data-v-20bbf06e] .unlabeled-select{min-width:35%;height:100%}.responder .target[data-v-20bbf06e]{height:100%}", ""]);
// Exports
module.exports = exports;
